var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17525_124028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.8183C0.5 12.04 0.589615 12.2568 0.74651 12.4134C0.903404 12.57 1.11995 12.6599 1.3414 12.6599H13.2294C13.4509 12.6599 13.6674 12.57 13.8243 12.4134C13.9815 12.2568 14.0708 12.04 14.0708 11.8185V4.85742H0.5V11.8185V11.8183Z",
    fill: "#FFE4D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0706 4.07617H0.5V4.57464H14.0706V4.07617Z",
    fill: "#D95101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89516 1.68164H1.3414C1.11995 1.68164 0.903404 1.77153 0.74651 1.92815C0.589615 2.08477 0.5 2.30159 0.5 2.52304V3.50118H14.0706V2.52304C14.0706 2.30159 13.9815 2.08477 13.824 1.92815C13.6672 1.77126 13.4509 1.68164 13.2292 1.68164H11.8008V2.78344C11.8008 2.98909 11.6341 3.1558 11.4284 3.1558H10.6439C10.4383 3.1558 10.2716 2.98909 10.2716 2.78344V1.68164H4.29843V2.78344C4.29843 2.98909 4.13173 3.1558 3.9258 3.1558H3.14133C2.93568 3.1558 2.76898 2.98909 2.76898 2.78344V1.68164H1.89462H1.89516Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0706 3.49805H0.5V4.07414H14.0706V3.49805Z",
    fill: "#EE5A02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9284 0.712891H3.14453V2.78224H3.9284V0.712891Z",
    fill: "#616E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1455 0.341797C2.94001 0.341797 2.77344 0.508368 2.77344 0.713861V2.78321C2.77344 2.9887 2.94001 3.15527 3.1455 3.15527H3.92937C4.13486 3.15527 4.3017 2.9887 4.3017 2.78321V0.713861C4.3017 0.508368 4.13513 0.341797 3.92937 0.341797H3.1455ZM3.92937 2.78321H3.1455V0.713861H3.92937V2.78321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4284 0.712891H10.6445V2.78224H11.4284V0.712891Z",
    fill: "#616E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6455 0.341797C10.44 0.341797 10.2734 0.508368 10.2734 0.713861V2.78321C10.2734 2.9887 10.44 3.15527 10.6455 3.15527H11.4294C11.6349 3.15527 11.8014 2.9887 11.8014 2.78321V0.713861C11.8014 0.508368 11.6349 0.341797 11.4294 0.341797H10.6455ZM11.4294 2.78321H10.6455V0.713861H11.4294V2.78321Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17525_124028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5706,
    height: 12.3149,
    fill: "white",
    transform: "translate(0.5 0.341797)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.6cf8ad7f767606d30e8255d38cbca919.svg";
export { ForwardRef as ReactComponent };